import { useEffect, useReducer } from 'react';

import SignIn from './SignIn';
import SignUp from './SignUp';
import { EmailPasswordLoginParams, EmailPasswordLoginState } from './Types';
import { validateEmailPasswordLoginParams } from './Validator';
import { SignUpParams } from './SignUp/Types';
import { SignInParams } from './SignIn/Types';

const initialState: EmailPasswordLoginState = {
  isSigningUp: false,
  email: '',
  emailError: '',
  givenName: '',
  givenNameError: '',
  familyName: '',
  familyNameError: '',
  password: '',
  passwordError: '',
  forgotPassword: false,
};

function reducer(
  state: EmailPasswordLoginState,
  action: EmailPasswordLoginState,
) {
  return {
    ...state,
    ...action,
  };
}

const EmailPasswordLogin = (params: EmailPasswordLoginParams): JSX.Element => {
  validateEmailPasswordLoginParams(params);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { returnUrl, setStage, setShowProviderLogin } = params;
  const [state, setState] = useReducer(reducer, initialState);

  useEffect(() => {
    setShowProviderLogin(state.forgotPassword !== true);
  }, [state.forgotPassword]);

  const signUpSignInParams = {
    returnUrl,
    setStage,
    ...state,
    setState,
    client: params.client,
    router: params.router,
    location: params.location,
  };

  if (state.isSigningUp) {
    return SignUp(signUpSignInParams as SignUpParams);
  }
  return SignIn(signUpSignInParams as SignInParams);
};

export default EmailPasswordLogin;
